import React from 'react';
import type { JourneyCategory } from '../data/mock';

export type JourneyFilter = 'all' | JourneyCategory;

interface Props {
  value: JourneyFilter;
  onChange: (next: JourneyFilter) => void;
  counts: Record<JourneyFilter, number>;
}

const CHIPS: { key: JourneyFilter; label: string; tint: string }[] = [
  { key: 'all',         label: 'All',          tint: 'text-text bg-text/5 border-line' },
  { key: 'milestone',   label: 'Milestones',   tint: 'text-role-admin bg-role-admin/12 border-role-admin/30' },
  { key: 'achievement', label: 'Achievements', tint: 'text-warning bg-warning/10 border-warning/30' },
  { key: 'profile',     label: 'Profile',      tint: 'text-muted bg-muted/10 border-line' },
  { key: 'metric',      label: 'Metrics',      tint: 'text-chart bg-chart/10 border-chart/30' },
  { key: 'document',    label: 'Documents',    tint: 'text-info bg-info/10 border-info/30' },
];

export default function JourneyFilterBar({ value, onChange, counts }: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {CHIPS.map(c => {
        const active = value === c.key;
        const count = counts[c.key] ?? 0;
        return (
          <button
            key={c.key}
            type="button"
            onClick={() => onChange(c.key)}
            className={`inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border transition ${
              active
                ? `${c.tint} font-semibold ring-1 ring-inset ring-current/20`
                : 'text-muted bg-shell border-line hover:bg-surface/60'
            }`}
          >
            <span>{c.label}</span>
            <span className={`text-[10px] px-1.5 rounded-full ${active ? 'bg-text/10' : 'bg-surface/80'}`}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
